import React from "react";
import { Link } from "react-router-dom";

import "./goldenBallPromo.css";

const PROMO_QUESTIONS = [
  "Who will win the Golden Boot?",
  "Who will win the Golden Glove?",
  "Who will win the Golden Ball?",
];

const PROMO_ROTATE_MS = 2600;

const GoldenBallPromo = () => {
  const [questionIndex, setQuestionIndex] = React.useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setQuestionIndex((i) => (i + 1) % PROMO_QUESTIONS.length);
    }, PROMO_ROTATE_MS);
    return () => clearInterval(interval);
  }, []);

  return;

  return (
    <div className="goldenBallPromo">
      <div className="goldenBallPromo-content">
        <span className="goldenBallPromo-badge">Bonus Round! Bonus Rewards!!</span>
        <div className="goldenBallPromo-textTrack">
          {/* key forces a remount per question so the slide-up/fade-in
              animation replays on every rotation */}
          <p key={questionIndex} className="goldenBallPromo-text">
            {PROMO_QUESTIONS[questionIndex]}
          </p>
        </div>
      </div>
      <Link to="/bonus-questions" className="goldenBallPromo-cta">
        Predict Now
      </Link>
    </div>
  );
};

export default GoldenBallPromo;
